class AudioManager {
    constructor() {
        // Sons principaux avec préchargement
        this.music = new Audio(baseUrl + 'sounds/music2.mp3');
        this.buttonSound = new Audio(baseUrl + 'sounds/button.mp3');
        this.wheelSound = new Audio(baseUrl + 'sounds/roulette.mp3');

        // Configuration du volume
        this.music.volume = 0.3;
        this.buttonSound.volume = 0.3;
        this.wheelSound.volume = 0.3;

        // Précharger tous les fichiers audio
        this.music.preload = 'auto';
        this.buttonSound.preload = 'auto';
        this.wheelSound.preload = 'auto';

        // Déclencher le chargement
        this.music.load();
        this.buttonSound.load();
        this.wheelSound.load();

        // Configuration de la musique de fond
        this.music.loop = true;

        this.isPlaying = false;

        this.initializeWithIntro();
        this.handleOverlayClick();
    }

    initializeWithIntro() {
        const introVideo = document.getElementById('introVideo');
        const introBlock = document.querySelector('.Intro');
        const hasPlayedIntro = sessionStorage.getItem('introPlayed');

        if (introVideo && introBlock) {
            if (hasPlayedIntro) {
                introBlock.style.display = 'none';
                introBlock.remove();
            } else {
                introVideo.addEventListener('ended', () => {
                    introBlock.style.transition = 'opacity 0.8s';
                    introBlock.style.opacity = '0';

                    setTimeout(() => {
                        introBlock.remove();
                        sessionStorage.setItem('introPlayed', 'true');
                    }, 800);
                });
            }
        }

        this.initialize();
    }

    initialize() {
        const initSounds = () => {
            // Gestion du bouton "Je veux ma reco"
            const spinButton = document.querySelector('.js-spin');
            if (spinButton) {
                // Modification de l'événement click pour jouer les deux sons
                spinButton.addEventListener('click', () => {
                    this.playButtonSound();
                    this.playWheelSound();
                    // Désactiver le bouton après le clic
                    spinButton.style.pointerEvents = 'none';
                    spinButton.classList.add('disabled');
                }, { passive: true });
            }

            // Gestion des boutons de la page reco
            const recoButtons = document.querySelectorAll('.reco-btns .btn');
            if (recoButtons) {
                recoButtons.forEach(button => {
                    // Un seul gestionnaire d'événements click
                    button.addEventListener('click', (e) => {
                        this.playButtonSound();

                        if (button.getAttribute('href')) {
                            e.preventDefault();
                            setTimeout(() => {
                                window.location.href = button.getAttribute('href');
                            }, 700);
                        }
                    }, { passive: false });
                });
            }
        };

        // Si le DOM est déjà chargé
        if (document.readyState === 'complete' || document.readyState === 'interactive') {
            initSounds();
        } else {
            // Sinon attendre le chargement
            document.addEventListener('DOMContentLoaded', initSounds);
        }

        // Sauvegarder l'état avant de quitter la page
        window.addEventListener('beforeunload', () => {
            sessionStorage.setItem('musicPlaying', this.isPlaying);
        });
    }

    play() {
        // Vérifier si l'élément .wheel existe sur la page
        const wheelExists = document.querySelector('.wheel') !== null;

        if (!wheelExists) {
            console.log('Pas de musique : élément .wheel non trouvé');
            return;
        }

        // Créer une promesse de contexte audio
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();

        // Essayer de démarrer le contexte audio
        if (audioContext.state === 'suspended') {
            audioContext.resume();
        }

        this.music.play()
            .then(() => {
                this.isPlaying = true;
                console.log('Musique démarrée');
            })
            .catch(error => {
                console.warn('Erreur de lecture audio:', error);
                // En cas d'erreur, on essaie de jouer au premier clic
                document.addEventListener('click', () => {
                    if (!this.isPlaying) {
                        this.play();
                    }
                }, { once: true });
            });
    }

    playButtonSound() {
        this.buttonSound.currentTime = 0;
        this.buttonSound.play()
            .then(() => console.log('Son bouton joué'))
            .catch(error => console.warn('Erreur son bouton:', error));

    }

    playWheelSound() {
        this.wheelSound.currentTime = 0;
        this.wheelSound.play()
            .then(() => console.log('Son roulette joué'))
            .catch(error => console.warn('Erreur son roulette:', error));
    }

    pause() {
        this.music.pause();
        this.isPlaying = false;
    }

    toggle() {
        if (this.isPlaying) {
            this.pause();
        } else {
            this.play();
        }
    }

    handleOverlayClick() {
        document.addEventListener('DOMContentLoaded', () => {
            const overlay = document.querySelector('.Overlay');
            const introVideo = document.getElementById('introVideo');
            const wheelExists = document.querySelector('.wheel') !== null;

            if (overlay) {
                console.log('Overlay trouvé');
                overlay.addEventListener('click', () => {
                    console.log('Overlay cliqué');
                    this.playButtonSound();
                    overlay.classList.add('isHidden');

                    setTimeout(() => {
                        if (introVideo) {
                            introVideo.muted = false;
                            introVideo.play()
                                .then(() => {
                                    console.log('Vidéo démarrée avec son');
                                    if (wheelExists) {
                                        introVideo.addEventListener('ended', () => {
                                            this.play();
                                        });
                                    }
                                })
                                .catch(error => console.warn('Erreur lecture vidéo:', error));
                        } else if (wheelExists) {
                            this.play();
                        }
                    }, 700);

                    setTimeout(() => {
                        overlay.remove();
                    }, 500);
                });

                document.addEventListener('keydown', () => {
                    if (!overlay.classList.contains('isHidden')) {
                        overlay.click();
                    }
                });
            } else if (wheelExists) {
                this.play();
            }
        });
    }
}

// Créer une instance unique
const audioManager = new AudioManager();
export default audioManager;